import { ACTIONS_GUIDE_SECTIONS } from './actionsGuideData';

/** Same col widths on every risk table so columns line up one under another. */
const COL_SITUATION = '42%';
const COL_AUTO = '33%';
const COL_SUPPORT = '25%';

function GuideTable({ criterion, rows }) {
  return (
    <div className="overflow-x-auto rounded-xl border border-slate-200 dark:border-slate-700">
      <table className="w-full table-fixed border-collapse text-left text-sm">
        <colgroup>
          <col style={{ width: COL_SITUATION }} />
          <col style={{ width: COL_AUTO }} />
          <col style={{ width: COL_SUPPORT }} />
        </colgroup>
        <thead>
          <tr className="border-b border-slate-200 bg-slate-50 text-slate-500 dark:border-slate-700 dark:bg-slate-900/80 dark:text-slate-400">
            <th className="px-3 py-2.5 text-left text-xs font-semibold sm:px-4">{criterion}</th>
            <th className="px-3 py-2.5 text-left text-xs font-semibold sm:px-4">Авто (push / email / SMS)</th>
            <th className="px-3 py-2.5 text-left text-xs font-semibold sm:px-4">Поддержка</th>
          </tr>
        </thead>
        <tbody>
          {rows.map(([situation, auto, support]) => (
            <tr
              key={situation}
              className="border-b border-slate-100 last:border-0 dark:border-slate-800"
            >
              <td className="px-3 py-3 align-top break-words text-slate-800 dark:text-slate-100 sm:px-4">
                {situation}
              </td>
              <td className="px-3 py-3 align-top break-words text-slate-600 dark:text-slate-300 sm:px-4">
                {auto}
              </td>
              <td className="px-3 py-3 align-top break-words text-slate-600 dark:text-slate-300 sm:px-4">
                {support}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

/** Tab «Правила» — Eisenhower tables only (KB риски-эйзенхауэр-таблицы.md). */
export default function ActionsGuidePage() {
  return (
    <section className="mx-auto max-w-4xl space-y-8">
      <h1 className="text-xl font-semibold text-slate-900 dark:text-white">Риски: кто действует</h1>

      {ACTIONS_GUIDE_SECTIONS.map((section) => (
        <article key={section.id} className="space-y-3">
          <h2 className="text-base font-semibold text-slate-900 dark:text-white">{section.title}</h2>
          <div className="space-y-2 text-sm leading-relaxed text-slate-600 dark:text-slate-300">
            {section.lead.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>
          <GuideTable criterion={section.criterion} rows={section.rows} />
        </article>
      ))}
    </section>
  );
}
